<template>
    <div class="g10c-sticky" role="region" aria-label="إجراءات سريعة">
        <button
            type="button"
            class="g10c-sticky__btn g10c-sticky__btn--secondary"
            @click="$emit('download-open')"
        >
            حمّل الكتاب
        </button>
        <router-link
            :to="courseRoute"
            class="g10c-sticky__btn g10c-sticky__btn--primary"
            @click.native="$emit('course-click')"
        >
            ابدأ الكورس
        </router-link>
    </div>
</template>

<script>
export default {
    name: 'CurriculumMobileSticky',
    props: {
        courseRoute: { type: [Object, String], required: true },
        arabicBookUrl: { type: String, default: '' },
        englishBookUrl: { type: String, default: '' },
    },
};
</script>
